function chunkArr(array, size) {
  //获取数组的长度，如果你传入的不是数组，那么获取到的就是undefined
  const length = array.length
  //判断不是数组，或者size没有设置，size小于1，就返回空数组
  if (!length || !size || size < 1) {
    return []
  }
  //核心部分
  let index = 0 //用来表示切割元素的范围start
  let resIndex = 0 //用来递增表示输出数组的下标

  //根据length和size算出输出数组的长度，并且创建它。
  let result = new Array(Math.ceil(length / size))
  //进行循环
  while (index < length) {
    //循环过程中设置result[0]和result[1]的值。该值根据array.slice切割得到。
    result[resIndex++] = array.slice(index, (index += size))
  }
  //输出新数组
  return result
}
// 日期格式化
function format(data, pat) {
  var year = data.getFullYear();
  var month = data.getMonth() + 1;
  var day = data.getDate();
  var hour = data.getHours();
  var minute = data.getMinutes();
  var second = data.getSeconds();

  // 两位补齐
  var autocomplete = function (int) {
    if (isNaN(int)) {
      int = 0;
    }
    return int > 9 ? int : "0" + int;
  };

  if (!pat) {
    pat = "YYYY-MM-DD";
  }

  pat = pat.replace(/YYYY/g, year);
  pat = pat.replace(/MM/g, autocomplete(month));
  pat = pat.replace(/DD/g, autocomplete(day));
  pat = pat.replace(/hh/gi, autocomplete(hour));
  pat = pat.replace(/mm/g, autocomplete(minute));
  pat = pat.replace(/ss/g, autocomplete(second));

  return pat;
}
function isEmail(email) {
  return /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/i.test(email);
}
// 验证是否为合法的手机号码
function isMobile(phone) {
  console.log(phone)
  return /^1(2|3|4|5|6|7|8|9)\d{9}$/.test(phone);
};

module.exports = {
  chunkArr: chunkArr,
  format:format,
  isEmail:isEmail,
  isMobile:isMobile
}